<template>
    <div v-if="open" class="modal" @click="closeModal">
        <div class="modal__inner">
            <iframe
                :src="`https://player.vimeo.com/video/366762398?autoplay=${autoplay}`"
                width="1280"
                height="720"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
            ></iframe>
            <div class="footnote">
                The following footage was filmed before the Covid-19 outbreak.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        autoplay: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            open: false,
        }
    },

    mounted() {
        this.$root.$on("modalOpen", (data) => {
            this.openModal()
        })
    },
    methods: {
        closeModal() {
            this.open = false
        },

        openModal() {
            this.open = true
        },
    },
}
</script>

<style lang="scss" scoped>
.modal {
    position: fixed;
    height: 100vh;
    width: 100vw;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5000;
    top: 0;
    left: 0;

    &__inner {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
}

iframe {
    max-width: 90%;

    // limit iframe size so clicking outside will close modal
    max-height: 56.25vw;
}

.footnote {
    color: var(--quaternary_colour);
    font-size: 0.75rem;
    flex-basis: 90%;
    text-align: center;
    margin-top: 1em;
}
</style>
